import React from 'react';
import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

import c from 'classnames';

import './style.scss';

const MenuSocial = (props) => {
  const {
    id = 'social',
    inverse = false,
    showLabels = false,
    removeFromNavigation = false,
  } = props;

  const classes = c('SocialMenu', id, {
    inverse,
  });

  return (
    <div className={classes}>
      <Menu id={id}>
        {(items) => {
          return (
            <>
              {items.map((item) => {
                if (item) {
                  const className = item.getIn(['link', 'options', 'attributes', 'class'], [])
                    .join(' ');
                  const title = item.getIn(['link', 'title'], 'Untitled');
                  const url = item.getIn(['link', 'url'], '');

                  return (
                    <div key={title} className="SocialMenu__item">
                      <CoreLink
                        ariaLabel={title}
                        className="SocialMenu__item__link"
                        href={url}
                        {...(removeFromNavigation && { tabIndex: -1 })}
                      >
                        <span
                          className={`icon icon-${className} ${inverse ? 'icon-variant-2' : ''}`}
                        />
                        {showLabels && title}
                      </CoreLink>
                    </div>
                  );
                }
              })}
            </>
          );
        }}
      </Menu>
    </div>
  );
};

export default MenuSocial;
